import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";
import { toast } from "react-toastify";
import Utils from "../../utils";

import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import { useLocation, useNavigate } from "react-router-dom";
import { getwarHouseEntityList } from "../../services/PartsInventory";
import Dropdown from "react-bootstrap/Dropdown";
import {
  getSerachClientProfile,
  getSerachUserProfile,
} from "../../services/ClientProfileServices";
import Select from "react-select";
import { getInternalSalesDetails } from "../../services/PartTypeService";
import {
  Button,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  deleteMainTasks,
  getTasksDetails,
  getTasksList,
  taskConvertToReservation,
  taskConvertToSales,
  updateWorkingStatus,
  updateTaskStatus,
} from "../../services/TaskServices";
import {
  getCommonSearchList,
  getSettingsCompanyDetails,
} from "../../services/settingsServices";
import { Range } from "react-range";
import { tConstStatic } from "../../utils/constantsTranslator";
import { Form } from "react-bootstrap";
import {
  getDocumentSetList,
  getListCustomerList,
} from "../../services/MoloniServices";

const covertSalesList = [
  { value: 1, label: "Internal" },
  { value: 2, label: "Marketplace" },
];

const Task = () => {
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [settingCompanyDetails, setSettingCompanyDetails] = useState("");
  const [tasksFilterData, setTasksFilterData] = useState({
    tasks_status: "",
    priority_from: "",
    priority_to: "",
    start_date: "",
    end_date: "",
    working_status: "",
    order_field: settingCompanyDetails?.task_sort_field ?? "",
    order_type: settingCompanyDetails?.task_sort_type ?? "",
    user_id: "",
    task_type: "",
    working_status: "",
    search_client: "",
  });

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    is_reload: false,
    company_id: companyId.company_id || 0,
    search: "",
    tasks_status: "",
    date_from: "",
    date_to: "",
    task_type: "",
    priority_from: 0,
    priority_to: "",
    user_id: "",
    working_status: "",
    order_field: "",
    order_type: "",
    search_client: "",
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [tasksListData, setTasksListData] = useState([]);
  const [show, setShow] = useState(false);
  const [entityList, setEntityList] = useState([]);
  const [userDataMainList, setUserDataMainList] = useState([]);
  const [taskStatusList, setTaskStatusList] = useState([]);
  const [priceValues, setPriceValues] = useState([0, 0]);
  const [taskSortList, setTaskSortList] = useState([]);
  const [tasksortTypeList, setTasksortTypeList] = useState([]);
  const [userDataList, setUserDataList] = useState([]);
  const [delModal, setDelModal] = useState(false);
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [delpart, setDelPart] = useState("");
  const [WorkingStatusData, setWorkingStatusData] = useState(false);
  const [rowStatusData, setRowStatusData] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [taskDetails, setTaskDetails] = useState("");
  const [modifyConvertRes, setModifyConvertRes] = useState(false);
  const [storeTaskId, setStoreTaskId] = useState("");
  const [clientResData, setClientResData] = useState({
    tasks_id: "",
    reservation_end_date: "",
    warehouses_id: "",
    users_id: [],
    shipping_price: "",
    packing_price: "",
    parcel_price: "",
    reservation_notes: "",
    send_email: 0,
    send_whatsapp: 0,
    reservation_end_alert: "",
    reservation_name: "",
    client_name: "",
    client_country_code: "",
    client_district: "",
    client_city: "",
    client_bill_address: "",
    client_postal_code: "",
    client_shipping_addresses: [],
    client_vat_country_code: "",
    client_vat_number: "",
    client_vat_percentage: 20,
    client_is_vat_exempt: "0",
    client_indicative_phone_code: "+1",
    client_phone_number: "",
    client_whatsapp_number: "",
    client_email: "",
    seller_id: "",
    sales_notes: "",
    sales_type: "",
    date: new Date().toISOString().split("T")[0],
    expiration_date: new Date().toISOString().split("T")[0],
    document_set_id: "",
    customer_id: "",
    our_reference: "",
    your_reference: "",
  });

  let errorsObj = {
    seller_id: "",
    sales_notes: "",
    sales_type: "",
    document_set_id: "",
    expiration_date: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [clientDataList, setClientDataList] = useState([]);
  const [selectedEntities, setSelectedEntities] = useState({});

  const [selectedPrices, setSelectedPrices] = useState({});

  const [resOrderData, setResOrderData] = useState({
    reservation_order_notes: "",
  });

  const [entityTaskList, setEntityTaskList] = useState([]);
  const [modifyconverToSales, setModifyconverToSales] = useState(false);
  const [modifyUpdateTask, setModifyUpdateTask] = useState(false);
  const [loading, setLoading] = useState(true);
  const [documentSetList, setDocumentSetList] = useState([]);
  const [customerList, seCustomerList] = useState([]);

  const handleUpdateTaskOpen = () => {
    setModifyUpdateTask(true);
  };

  const handleUpdateTaskClose = () => {
    setModifyUpdateTask(false);
  };

  const handleConvertToSaleOpen = (e, item) => {
    setStoreTaskId(item);
    setModifyconverToSales(true);
  };

  const handleConvertToSaleClose = () => {
    setModifyconverToSales(false);
    setErrors({
      seller_id: "",
      sales_notes: "",
      sales_type: "",
      date: "",
      document_set_id: "",
      customer_id: "",
      expiration_date: "",
    });
  };

  const handleSelectChange = (event, item) => {
    const value = event.target.value;

    setSelectedEntities((prevState) => ({
      ...prevState,
      [item.id]: value,
    }));
  };

  const handleManualInput = (partId, value) => {
    setSelectedPrices((prev) => ({
      ...prev,
      [partId]: value,
    }));
  };

  const handleCheckboxChangeSendEmail = (e) => {
    setClientResData({
      ...clientResData,
      send_email: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangeWhatsapp = (e) => {
    setClientResData({
      ...clientResData,
      send_whatsapp: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChange = (e) => {
    setClientResData({
      ...clientResData,
      client_is_vat_exempt: e.target.checked ? 1 : 0,
    });
  };

  const handleConvertToResClose = () => {
    setModifyConvertRes(false);
  };

  const handleConvertToResOpen = (e, item) => {
    setStoreTaskId(item);
    setModifyConvertRes(true);
  };

  const handleShowOpen = () => {
    setShow(true);
  };

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelPart(item.id);
    setDelModal(true);
  };

  const handleShowClose = () => {
    setShow(false);
  };

  const onDeleteModalClose = () => {
    setDelModal(false);
  };

  useEffect(() => {
    let data = { ...params };
    getwarHouseEntityList(data)
      .then((response) => {
        setEntityTaskList(response.data.data);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, [params]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDocumentSetList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDocumentSetList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCustomerList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        seCustomerList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (taskDetails) {
      setClientResData({
        ...clientResData,
        tasks_id: taskDetails?.id,

        client_name: taskDetails?.client_name,
        client_country_code: taskDetails?.client_country_code,
        client_district: taskDetails?.client_district,
        client_city: taskDetails?.client_city,
        client_bill_address: taskDetails?.client_bill_address,
        client_postal_code: taskDetails?.client_postal_code,
        client_shipping_addresses: taskDetails?.client_shipping_addresses,
        client_vat_country_code: taskDetails?.client_vat_country_code,
        client_vat_number: taskDetails?.client_vat_number,
        client_vat_percentage: taskDetails?.client_vat_percentage,
        client_is_vat_exempt: taskDetails?.client_is_vat_exempt,
        client_indicative_phone_code: taskDetails?.client_indicative_phone_code,
        client_phone_number: taskDetails?.client_phone_number,
        client_whatsapp_number: taskDetails?.client_whatsapp_number,
        client_email: taskDetails?.client_email,
        user_list: taskDetails?.user_list,
        tasks_status: taskDetails?.tasks_status,
        date: taskDetails?.date,
        expireation_date: taskDetails?.expireation_date,
        document_set_id: taskDetails?.document_set_id,
        customer_id: taskDetails?.customer_id,
        our_reference: taskDetails?.our_reference,
        your_reference: taskDetails?.your_reference,
      });
    }
  }, [taskDetails]);

  useEffect(function () {
    const obj = {
      search: "",
      limit: 20,
      page: 1,
    };
    getSerachClientProfile(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
            fullData: response.data[i],
          });
        }

        setClientDataList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (storeTaskId) {
      let data = {
        id: storeTaskId?.id,
      };

      getTasksDetails(data)
        .then((response) => {
          setTaskDetails(response.data.data);
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  }, [storeTaskId]);

  useEffect(() => {
    if (settingCompanyDetails) {
      setTasksFilterData({
        ...tasksFilterData,
        order_field: settingCompanyDetails?.task_sort_field ?? "",
        order_type: settingCompanyDetails?.task_sort_type ?? "",
      });
    }
  }, [settingCompanyDetails]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "task_status",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTaskStatusList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "task_sort_field",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTaskSortList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "task_sort_type",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTasksortTypeList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    const obj = {
      limit: 20,
      page: 1,
      search: "",
    };
    getSerachUserProfile(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setUserDataMainList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      is_reload: false,
    };

    getwarHouseEntityList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i]?.parent_ids,
            label: response.data[i]?.parent_names,
          });
        }
        setEntityList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    const obj = {
      search: "",
      limit: 20,
      page: 1,
    };
    getSerachUserProfile(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setUserDataList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const companyResponse = await getSettingsCompanyDetails();
        setSettingCompanyDetails(companyResponse.data.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSettings();
  }, []);

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("filterData");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    if (savedPage) {
      setParams((prevParams) => ({
        ...prevParams,
        page: parseInt(savedPage, 10),
      }));
    }
  }, [location.pathname, params]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1; // ReactPaginate starts from 0, so we add 1
      localStorage.setItem("lastVisitedPage", e.selected + 1); // Save the selected page to localStorage
    }
    paramsObj.tasks_status = tasksFilterData?.tasks_status;
    paramsObj.task_type = tasksFilterData?.task_type;
    paramsObj.user_id = tasksFilterData?.user_id;
    paramsObj.date_from = tasksFilterData.date_start;
    paramsObj.date_to = tasksFilterData.date_end;
    paramsObj.working_status = tasksFilterData?.working_status;
    paramsObj.order_field = tasksFilterData?.order_field;
    paramsObj.order_type = tasksFilterData?.order_type;
    paramsObj.search_client = tasksFilterData?.search_client;
    paramsObj.priority_from = priceValues[0];
    paramsObj.priority_to = priceValues[1];

    localStorage.setItem("filterData", JSON.stringify(paramsObj));
    setParams(paramsObj);
    setShow(false);
  };

  useEffect(() => {
    const savedFilterData = localStorage.getItem("filterData");
    if (savedFilterData) {
      const parsedFilterData = JSON.parse(savedFilterData);

      setParams(parsedFilterData);
    }
  }, []);

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("filterData"));
    if (savedData) {
      setTasksFilterData({
        sales_type: savedData?.sales_type,
        seller_id: savedData?.seller_id,
        warehouse_id: savedData?.warehouse_id,
      });
    }
  }, []);

  const ResetModal = () => {
    setParams({
      limit: tableLengthList[0],
      page: 1,
      search: "",
      is_reload: false,
      company_id: companyId.company_id || 0,
      sales_type: 1,
      warehouse_id: "",
      seller_id: "",
      start_date: "",
      end_date: "",
    });
    setTasksFilterData({
      tasks_status: "",
      priority_from: "",
      priority_to: "",
      start_date: "",
      end_date: "",
      working_status: "",
      order_field: settingCompanyDetails?.task_sort_field ?? "",
      order_type: settingCompanyDetails?.task_sort_type ?? "",
      user_id: "",
      task_type: "",
      working_status: "",
      search_client: "",
    });

    setPriceValues([0, 0]);
    setShow(false);
    localStorage.removeItem("filterData");
  };

  const fetchGetTaskList = () => {
    let data = { ...params };
    setLoading(true);

    getTasksList(data)
      .then((response) => {
        setTasksListData(response.data.data);
        setTotalRecords(response.data.total);
        setLoading(false);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(
    function () {
      let data = { ...params };

      fetchGetTaskList(data);
    },
    [params]
  );

  const handleCheckboxWorkingChange = (e) => {
    setTasksFilterData({
      ...tasksFilterData,
      working_status: e.target.checked ? "1" : "0",
    });
  };

  const onDestoryMainTask = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { id: delpart };
    deleteMainTasks(data)
      .then((response) => {
        let data = { ...params };

        fetchGetTaskList(data);
        toast.success(response.data.message);
        setDelPart("");
        setDelModal(false);
        setIsDelButtonLoad(false);
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleStatusChangeConfirm = () => {
    const { id, newStatus } = selectedRow;
    setRowStatusData((prev) => ({
      ...prev,
      [id]: newStatus === 1,
    }));

    let data = {
      tasks_id: selectedRow?.id,
      id: companyId.id,
      status: selectedRow?.newStatus,
    };

    updateWorkingStatus(data)
      .then((res) => {
        toast.success(t("status_updated"));
        fetchGetTaskList();
      })
      .catch((err) => toast.error(Utils.getErrorMessage(err)))
      .finally(() => setWorkingStatusData(false));
  };

  const handleCloseStatus = () => {
    setWorkingStatusData(false);
  };

  const handleAddressChange = (index, value) => {
    const updatedAddresses = [...clientResData.client_shipping_addresses];
    updatedAddresses[index] = value;
    setClientResData({
      ...clientResData,
      client_shipping_addresses: updatedAddresses,
    });
  };

  const handleAddAddress = () => {
    setClientResData({
      ...clientResData,
      client_shipping_addresses: [
        ...clientResData.client_shipping_addresses,
        "",
      ],
    });
  };

  const handleRemoveAddress = (index) => {
    const updatedAddresses = [...clientResData.client_shipping_addresses];
    updatedAddresses.splice(index, 1);
    setClientResData({
      ...clientResData,
      client_shipping_addresses: updatedAddresses,
    });
  };

  const handleSubmitConvertToRes = (e) => {
    e.preventDefault();

    let isValid = true;

    let partListData = taskDetails.part_list
      .flatMap((part) =>
        part.part_qty_list.map((qtyItem) => {
          const matchedTaskOrder = part.tasks_order_list?.find(
            (order) => Number(order.part_qty_label_id) === Number(qtyItem.id)
          );

          const tasks_sales_price =
            selectedPrices[qtyItem.id] ??
            matchedTaskOrder?.tasks_sales_price ??
            null;

          const location_id =
            selectedEntities[qtyItem.id] ??
            matchedTaskOrder?.location_id ??
            null;

          const tasks_details_notes =
            resOrderData.reservation_order_notes?.[qtyItem.id] ??
            matchedTaskOrder?.tasks_details_notes ??
            "";

          return {
            parts_id: part.id,
            part_qty_label_id: qtyItem.id,
            tasks_sales_price,
            location_id,
            tasks_details_notes,
          };
        })
      )
      .filter((item) => {
        const isComplete =
          item.tasks_sales_price !== null &&
          item.tasks_sales_price !== "" &&
          item.location_id !== null &&
          item.location_id !== "" &&
          item.tasks_details_notes !== null &&
          item.tasks_details_notes !== "";

        if (
          (item.location_id ||
            item.tasks_sales_price ||
            item.tasks_details_notes) &&
          !isComplete
        ) {
          toast.error(
            `Please fill all required fields for Part Qty ID: ${item.part_qty_label_id}`
          );
          isValid = false;
        }

        return isComplete;
      });

    if (!isValid) return;

    let data = {
      tasks_id: taskDetails?.id,
      client_name: clientResData?.client_name,
      client_country_code: clientResData?.client_country_code,
      client_bill_address: clientResData?.client_bill_address,
      client_postal_code: clientResData?.client_postal_code,
      client_shipping_addresses: clientResData?.client_shipping_addresses,
      client_vat_country_code: clientResData?.client_vat_country_code,
      client_vat_number: clientResData?.client_vat_number,
      client_vat_percentage: clientResData?.client_vat_percentage,
      client_is_vat_exempt: clientResData?.client_is_vat_exempt,
      client_indicative_phone_code: clientResData?.client_indicative_phone_code,
      client_phone_number: clientResData?.client_phone_number,
      client_whatsapp_number: clientResData?.client_whatsapp_number,
      client_email: clientResData?.client_email,
      client_district: clientResData?.district?.label
        ? clientResData?.district?.label
        : clientResData?.state_name,
      client_city: clientResData?.city?.label
        ? clientResData?.city?.label
        : clientResData?.city_name,
      reservation_end_date: clientResData?.reservation_end_date,
      warehouses_id: clientResData?.warehouses_id,
      users_id: clientResData?.users_id,
      shipping_price: clientResData?.shipping_price,
      packing_price: clientResData?.packing_price,
      parcel_price: clientResData?.parcel_price,
      reservation_notes: clientResData?.reservation_notes,
      send_email: clientResData?.send_email,
      send_whatsapp: clientResData?.send_whatsapp,
      reservation_end_alert: clientResData?.reservation_end_alert,
      reservation_name: clientResData?.reservation_name,
      part_list: partListData,
    };

    taskConvertToReservation(data)
      .then((response) => {
        toast.success(response.data.message);
        setModifyConvertRes(false);
        setModifyUpdateTask(true);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleSubmitConvertToSales = (e) => {
    e.preventDefault();

    let error = false;
    let errorObj = { ...errorsObj };
    if (!clientResData.seller_id) {
      errorObj.seller_id = `Seller is required.`;
      error = true;
    }

    if (!clientResData.sales_notes) {
      errorObj.sales_notes = `Seller notes required.`;
      error = true;
    }
    if (!clientResData.sales_type) {
      errorObj.sales_type = `Seller type required.`;
      error = true;
    }

    // if (Number(settingCompanyDetails?.is_all_sync) === 1) {
    //   if (!clientResData.document_set_id) {
    //     errorObj.document_set_id = `Document Set is required.`;
    //     error = true;
    //   }

    //   if (!clientResData.expiration_date) {
    //     errorObj.expiration_date = `Expiration Date is required.`;
    //     error = true;
    //   }
    // }
    setErrors(errorObj);
    Utils.focusError();
    if (error) return;

    let isValid = true;

    let partListData = taskDetails.part_list
      .flatMap((part) =>
        part.part_qty_list.map((qtyItem) => {
          const matchedTaskOrder = part.tasks_order_list?.find(
            (order) => Number(order.part_qty_label_id) === Number(qtyItem.id)
          );

          const tasks_sales_price =
            selectedPrices[qtyItem.id] ??
            matchedTaskOrder?.tasks_sales_price ??
            null;

          const location_id =
            selectedEntities[qtyItem.id] ??
            matchedTaskOrder?.location_id ??
            null;

          const tasks_details_notes =
            resOrderData.reservation_order_notes?.[qtyItem.id] ??
            matchedTaskOrder?.tasks_details_notes ??
            "";

          return {
            parts_id: part.id,
            part_qty_label_id: qtyItem.id,
            tasks_sales_price,
            location_id,
            tasks_details_notes,
          };
        })
      )
      .filter((item) => {
        const isComplete =
          item.tasks_sales_price !== null &&
          item.tasks_sales_price !== "" &&
          item.location_id !== null &&
          item.location_id !== "" &&
          item.tasks_details_notes !== null &&
          item.tasks_details_notes !== "";

        if (
          (item.location_id ||
            item.tasks_sales_price ||
            item.tasks_details_notes) &&
          !isComplete
        ) {
          toast.error(
            `Please fill all required fields for Part Qty ID: ${item.part_qty_label_id}`
          );
          isValid = false;
        }

        return isComplete;
      });

    if (!isValid) return;

    let data = {
      tasks_id: taskDetails?.id,
      client_name: clientResData?.client_name,
      client_country_code: clientResData?.client_country_code,
      client_bill_address: clientResData?.client_bill_address,
      client_postal_code: clientResData?.client_postal_code,
      client_shipping_addresses: clientResData?.client_shipping_addresses,
      client_vat_country_code: clientResData?.client_vat_country_code,
      client_vat_number: clientResData?.client_vat_number,
      client_vat_percentage: clientResData?.client_vat_percentage,
      client_is_vat_exempt: clientResData?.client_is_vat_exempt,
      client_indicative_phone_code: clientResData?.client_indicative_phone_code,
      client_phone_number: clientResData?.client_phone_number,
      client_whatsapp_number: clientResData?.client_whatsapp_number,
      client_email: clientResData?.client_email,
      client_district: clientResData?.client_district,
      client_city: clientResData?.client_city,
      seller_id: clientResData?.seller_id,
      sales_notes: clientResData?.sales_notes,
      sales_type: clientResData?.sales_type,
      expiration_date: clientResData?.expiration_date,
      document_set_id: clientResData?.document_set_id,
      part_list: partListData,
    };

    taskConvertToSales(data)
      .then((response) => {
        toast.success(response.data.message);
        setModifyconverToSales(false);
        setModifyUpdateTask(true);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const renderOptions = (nodes, level = 0) => {
    return nodes?.map((node) => {
      if (node.children && node.children.length > 0) {
        return (
          <>
            <optgroup
              label={"\u00A0\u00A0".repeat(level) + node.warehouse_name}
              key={node.id}
            />
            {renderOptions(node.children, level + 1)}
          </>
        );
      } else {
        return (
          <option value={node.id} key={node.id}>
            {"\u00A0\u00A0".repeat(level) + node.warehouse_name}
          </option>
        );
      }
    });
  };

  const handleUpdateTaskSubmit = () => {
    let data = {
      id: storeTaskId?.id,
    };

    updateTaskStatus(data)
      .then((res) => {
        toast.success(res.data.message);
        setModifyUpdateTask(false);
        let data = { ...params };

        fetchGetTaskList(data);
      })
      .catch((err) => toast.error(Utils.getErrorMessage(err)));
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                {/* <h1 className="page-title">Part Type</h1> */}
              </div>
              <div className="col-sm-6"></div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        <section className="content">
          <div className="container-fluid container-custom-height-new ">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="card-header">
                    <div
                      className="card-title m-0 float-left"
                      style={{ width: "50%" }}
                    >
                      <input
                        type="text"
                        className="form-control"
                        value={params.search}
                        onChange={(e) => handleParams(e, "search")}
                        placeholder={t("search")}
                      ></input>
                    </div>

                    {show && (
                      <div
                        className="offcanvas-backdrop show"
                        onClick={(e) => e.stopPropagation()}
                      ></div>
                    )}

                    <div className="card-title m-0 float-right rightBtn">
                      <button
                        type="button"
                        className="btn mr-2 btn-icon-text"
                        onClick={() => navigate("/add-tasks")}
                      >
                        <i className="bi bi-plus-lg"></i>
                        <span className="ms-2">{t("Add")}</span>
                      </button>

                      <button
                        type="button"
                        className="btn-icon-text mr-2 mr-2"
                        onClick={handleShowOpen}
                      >
                        <i className="bi bi-funnel"></i>
                        {t("filter")}
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="vehicleThBg table-responsive table-responsive-vehicle">
                      <table className="table table-bordered rounded-table table-striped table-hover">
                        <thead>
                          <tr>
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("tasks_name")}
                            </th>
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("client_name")}
                            </th>{" "}
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("task_type")}
                            </th>{" "}
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("tasks_status")}
                            </th>{" "}
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              Working status
                            </th>{" "}
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              {t("action")}
                            </th>{" "}
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan={7} className="text-center py-4">
                                <div
                                  className="spinner-border text-primary"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ) : tasksListData?.length > 0 ? (
                            tasksListData?.map((item, index) => (
                              <tr key={item.id}>
                                {" "}
                                <td>{item?.tasks_name}</td>
                                <td>{item?.client_name}</td>
                                <td>{item?.task_type_name}</td>
                                <td>{tConstStatic(item?.status_name)}</td>
                                <td>
                                  {companyId?.id ===
                                  Number(item?.tasks_create_user_id) ? (
                                    <p
                                      style={{
                                        marginTop: "14px",
                                        color: "green",
                                        fontWeight: "700",
                                      }}
                                    >
                                      {"My Task"}
                                    </p>
                                  ) : (
                                    <div className="form-check form-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`switch-${item.id}`}
                                        checked={
                                          rowStatusData[item.id] ??
                                          item.working_status === 1
                                        }
                                        onChange={(e) => {
                                          setSelectedRow({
                                            id: item.id,
                                            newStatus: e.target.checked ? 1 : 0,
                                          });
                                          setWorkingStatusData(true);
                                        }}
                                      />
                                    </div>
                                  )}
                                </td>
                                <td>
                                  <div className="d-flex">
                                    <Dropdown
                                      className="iconDropdown"
                                      onToggle={(isOpen) => {
                                        if (isOpen) {
                                          // This logic runs when the dropdown is opened
                                          const tableResponsive =
                                            document.querySelector(
                                              ".table-responsive"
                                            );
                                          if (window.innerWidth <= 767) {
                                            if (tableResponsive) {
                                              tableResponsive.style.overflowX =
                                                "auto !important";
                                              tableResponsive.style.overflowY =
                                                "auto !important";
                                            }
                                          } else {
                                            if (tableResponsive) {
                                              tableResponsive.style.overflowX =
                                                "inherit !important";
                                              tableResponsive.style.overflowY =
                                                "inherit !important";
                                            }
                                          }
                                        }
                                      }}
                                    >
                                      <Dropdown.Toggle
                                        variant="success"
                                        id="dropdown-basic"
                                        className="iconToggle"
                                      >
                                        <i className="bi bi-three-dots-vertical"></i>
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu>
                                        <Dropdown.Item
                                          href="#/action-1"
                                          className="d-flex"
                                          onClick={() =>
                                            navigate(`/add-tasks/${item.id}`, {
                                              state: item,
                                            })
                                          }
                                        >
                                          <>
                                            <div className="edit-btn" href="#">
                                              <i className="bi bi-pencil"></i>
                                            </div>
                                            <span>{t("edit")}</span>
                                          </>
                                        </Dropdown.Item>

                                        {item?.task_type === 1 && (
                                          <Dropdown.Item
                                            href="#/action-1"
                                            className="d-flex"
                                            onClick={(e) =>
                                              handleConvertToResOpen(e, item)
                                            }
                                          >
                                            <>
                                              <div
                                                className="edit-btn"
                                                href="#"
                                              >
                                                <i className="bi bi-pencil"></i>
                                              </div>
                                              <span>Convert To Reserve</span>
                                            </>
                                          </Dropdown.Item>
                                        )}

                                        {item?.task_type === 1 && (
                                          <Dropdown.Item
                                            href="#/action-1"
                                            className="d-flex"
                                            onClick={(e) =>
                                              handleConvertToSaleOpen(e, item)
                                            }
                                          >
                                            <>
                                              <div
                                                className="edit-btn"
                                                href="#"
                                              >
                                                <i className="bi bi-pencil"></i>
                                              </div>
                                              <span>Convert To Sales</span>
                                            </>
                                          </Dropdown.Item>
                                        )}

                                        <Dropdown.Item
                                          href="#/action-2"
                                          className="d-flex"
                                          onClick={(e) =>
                                            onDeleteModalOpen(e, item)
                                          }
                                        >
                                          <>
                                            <div className="trash-btn delete-btn">
                                              <i className="bi bi-trash3"></i>
                                            </div>
                                            <span>{t("delete")}</span>
                                          </>
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={7} className="text-center">
                                {t("no_record_found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer card-footer-part clearfix">
            <div className="pagination pagination-sm m-0 float-right">
              <ReactPaginate
                previousLabel={<i className="bi bi-chevron-double-left"></i>}
                nextLabel={<i className="bi bi-chevron-double-right"></i>}
                breakLabel={"..."}
                pageCount={Math.ceil(totalRecords / params.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(e) => handleParams(e, "pagination")}
                forcePage={params.page - 1}
                containerClassName={"pagination"}
                activeClassName={"active"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
              />
            </div>
          </div>
        </section>
      </div>

      <div
        className={`offcanvas offcanvas-end ${show ? "show" : ""}`}
        tabIndex="-1"
        id="staticBackdrop"
        aria-labelledby="staticBackdropLabel"
        style={{ visibility: show ? "visible" : "hidden" }}
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="staticBackdropLabel">
            {t("filter")}
          </h5>

          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleShowClose}
          ></button>
        </div>

        <div className="offcanvas-body">
          <div>
            <div href="#/action-2">
              <div className="Label-my">
                Task Status{" "}
                <Select
                  className="my-select-v"
                  options={taskStatusList}
                  value={
                    taskStatusList.find(
                      (item) => item.value == tasksFilterData.tasks_status
                    ) || null
                  }
                  onChange={(selectedOption) => {
                    setTasksFilterData({
                      ...tasksFilterData,
                      tasks_status: selectedOption ? selectedOption.value : "",
                    });
                  }}
                  isSearchable={true}
                  isClearable={true}
                  placeholder={"Select Task Status"}
                />
              </div>
            </div>

            <div href="#/action-2">
              <div className="Label-my">
                {"Select Task Sort field"}
                <Select
                  options={taskSortList}
                  value={
                    taskSortList.find(
                      (option) => option.value === tasksFilterData.order_field
                    ) || ""
                  }
                  onChange={(selectedOption) => {
                    setTasksFilterData({
                      ...tasksFilterData,
                      order_field: selectedOption ? selectedOption.value : "",
                    });
                  }}
                  placeholder={"Select Task Sort field"}
                  isSearchable={true}
                  isClearable={true}
                />
              </div>
            </div>

            <div href="#/action-2">
              <div className="Label-my">
                {"Select Task Sort type"}
                <Select
                  options={tasksortTypeList}
                  value={
                    tasksortTypeList.find(
                      (option) => option.value === tasksFilterData.order_type
                    ) || ""
                  }
                  onChange={(selectedOption) => {
                    setTasksFilterData({
                      ...tasksFilterData,
                      order_type: selectedOption ? selectedOption.value : "",
                    });
                  }}
                  placeholder={"Select Task Sort type"}
                  isSearchable={true}
                  isClearable={true}
                />
              </div>
            </div>

            <div href="#/action-2">
              <div className="Label-my">
                {"Select UserList"}
                <Select
                  options={userDataList}
                  value={userDataList.find(
                    (option) => option.value === tasksFilterData.user_id
                  )}
                  onChange={(selectedOption) =>
                    setTasksFilterData({
                      ...tasksFilterData,
                      user_id: selectedOption.value,
                    })
                  }
                  placeholder={"Select UserList"}
                />
              </div>
            </div>

            <div href="#/action-2">
              <div className="Label-my">
                Start Date
                <input
                  type="date"
                  className="form-control"
                  value={tasksFilterData.date_start}
                  onChange={(e) =>
                    setTasksFilterData({
                      ...tasksFilterData,
                      date_start: e.target.value,
                    })
                  }
                />
              </div>
            </div>

            <div href="#/action-2">
              <div className="Label-my">
                End Date
                <input
                  type="date"
                  className="form-control"
                  value={tasksFilterData.date_end}
                  onChange={(e) =>
                    setTasksFilterData({
                      ...tasksFilterData,
                      date_end: e.target.value,
                    })
                  }
                />
              </div>
            </div>

            <div href="#/action-2">
              <div className="Label-my">
                {t("searchClient")}
                <input
                  className="form-control input-search"
                  type="text"
                  value={tasksFilterData.search_client}
                  onChange={(e) => {
                    setTasksFilterData({
                      ...tasksFilterData,
                      search_client: e.target.value,
                    });
                  }}
                  name={`search_client`}
                  maxLength={100}
                  placeholder={t("search_client")}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div href="#/action-2">
                  <div className="Label-my">
                    Priority
                    <div style={{ marginTop: "10px" }}>
                      <Range
                        step={1}
                        min={0}
                        max={5}
                        values={priceValues}
                        onChange={setPriceValues}
                        renderTrack={({ props, children }) => (
                          <div
                            {...props}
                            style={{
                              ...props.style,
                              height: "6px",
                              width: "100%",
                              backgroundColor: "#ccc",
                            }}
                          >
                            {children}
                          </div>
                        )}
                        renderThumb={({ props }) => (
                          <div
                            {...props}
                            style={{
                              ...props.style,
                              height: "25px",
                              width: "25px",
                              backgroundColor: "#999",
                              marginTop: "1px",
                              borderRadius: "100px",
                            }}
                          />
                        )}
                      />
                    </div>
                    <div style={{ marginTop: "0.5rem" }}>
                      From: {priceValues[0]} &nbsp;&nbsp; To: {priceValues[1]}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div href="#/action-2">
                  <div className="Label-my">
                    Working Status
                    <div style={{ marginLeft: "15px" }}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={tasksFilterData.working_status === "1"}
                        onChange={handleCheckboxWorkingChange}
                      />
                      <label className="form-check-label">Working Status</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-around mb-3">
            <button
              style={{ marginTop: "9px", display: "flex" }}
              type="button"
              className="btn  btn-primary btn-filter"
              onClick={(e) => handleParams(e, "search")}
            >
              <span className="ms-1">{t("filter")}</span>
            </button>
            <button
              style={{ marginTop: "9px", display: "flex" }}
              type="button"
              className="btn  btn-primary ms-1 btn-filter"
              onClick={ResetModal}
            >
              <span className="ms-1 ">Reset</span>
            </button>
          </div>
        </div>
      </div>

      <Modal isOpen={delModal}>
        <ModalHeader>{`Delete Task`}</ModalHeader>
        <ModalBody>
          <p
            className={`mb-0`}
          >{`Are you sure you want to delete this task?`}</p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>

          {!isDelButtonLoad && (
            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={onDestoryMainTask}
            >{t("delete")}<i className="bi bi-trash3"></i>
            </button>
          )}
          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={WorkingStatusData}>
        <ModalHeader>{`Working Status`}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>{`Are you sure you want change the status?`}</p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleCloseStatus}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("no")}<i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "100px" }}
            onClick={handleStatusChangeConfirm}
          >{t("yes")}<i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyConvertRes} size="xl">
        <ModalHeader>{t("converted_to_reserves")}</ModalHeader>
        <Form method={`post`} onSubmit={handleSubmitConvertToRes}>
          <ModalBody>
            <div className="row">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("reservation_name")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            type="text"
                            className="form-control input-search"
                            value={clientResData.reservation_name}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                reservation_name: e.target.value,
                              });
                            }}
                            name="reservation_name"
                            placeholder={t("reservation_name")}
                          />
                          {errors.reservation_name && (
                            <span className="input-error">
                              {errors.reservation_name}
                            </span>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        Reservation end date
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            type="datetime-local"
                            className="form-control input-search"
                            value={clientResData.reservation_end_date}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                reservation_end_date: e.target.value,
                              });
                            }}
                            name="reservation_end_date"
                            placeholder={t("reservation_end_date")}
                          />
                          {errors.reservation_end_date && (
                            <span className="input-error">
                              {errors.reservation_end_date}
                            </span>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        Select User
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <Select
                            className="my-select-v"
                            options={userDataList}
                            value={userDataList.filter((item) =>
                              clientResData.users_id?.includes(item.value)
                            )}
                            onChange={(selectedOptions) => {
                              setClientResData({
                                ...clientResData,
                                users_id: selectedOptions
                                  ? selectedOptions.map((opt) => opt.value)
                                  : [],
                              });
                            }}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            placeholder={"Select Users"}
                          />
                          {errors.users_id && (
                            <span className="input-error">
                              {errors.users_id}
                            </span>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        Warehouse
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <Select
                            className="my-select-v"
                            options={entityList}
                            value={entityList.find(
                              (item) =>
                                item.value == clientResData.warehouses_id
                            )}
                            onChange={(selectedOption) => {
                              setClientResData({
                                ...clientResData,
                                warehouses_id: selectedOption
                                  ? selectedOption.value
                                  : "",
                              });
                            }}
                            isSearchable={true}
                            isClearable={true}
                            placeholder={"Select Warehouse"}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        Shipping Price
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            type="number"
                            className="form-control input-search"
                            value={clientResData.shipping_price}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                shipping_price: e.target.value,
                              });
                            }}
                            name="shipping_price"
                            placeholder={t("shipping_price")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("packing_price")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            type="number"
                            className="form-control input-search"
                            value={clientResData.packing_price}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                packing_price: e.target.value,
                              });
                            }}
                            name="packing_price"
                            placeholder={t("packing_price")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("parcel_price")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            type="number"
                            className="form-control input-search"
                            value={clientResData.parcel_price}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                parcel_price: e.target.value,
                              });
                            }}
                            name="parcel_price"
                            placeholder={t("parcel_price")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("reservation_notes")}{" "}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <textarea
                            type="text"
                            className="form-control input-search"
                            value={clientResData.reservation_notes}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                reservation_notes: e.target.value,
                              });
                            }}
                            name="reservation_notes"
                            rows={3}
                            placeholder={t("reservation_notes")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label">
                        {t("send_email")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div mt-12">
                          <div className="form-check">
                            <input
                              className="my-checkbox-1 form-check-input"
                              type="checkbox"
                              checked={clientResData.send_email}
                              onChange={handleCheckboxChangeSendEmail}
                            />
                            <label className="form-check-label pl-6">
                              {t("send_email")}
                            </label>
                          </div>
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label">
                        {t("send_whatsapp")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div mt-12">
                          <div className="form-check">
                            <input
                              className="my-checkbox-1 form-check-input"
                              type="checkbox"
                              checked={clientResData.send_whatsapp}
                              onChange={handleCheckboxChangeWhatsapp}
                            />
                            <label className="form-check-label pl-6">
                              {t("send_whatsapp")}
                            </label>
                          </div>
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        Reservation end date alert
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            type="datetime-local"
                            className="form-control input-search"
                            value={clientResData.reservation_end_alert}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                reservation_end_alert: e.target.value,
                              });
                            }}
                            name="reservation_end_alert"
                            placeholder={t("reservation_end_date_alert")}
                          />
                          {errors.reservation_end_alert && (
                            <span className="input-error">
                              {errors.reservation_end_alert}
                            </span>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label">
                        {t("client_is_vat_exempt")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div mt-12">
                          <div className="form-check">
                            <input
                              className="my-checkbox-1 form-check-input"
                              type="checkbox"
                              checked={clientResData.client_is_vat_exempt}
                              onChange={handleCheckboxChange}
                            />
                            <label className="form-check-label pl-6">
                              {t("client_is_vat_exempt")}
                            </label>
                          </div>
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("client_name")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            type="text"
                            className="form-control input-search"
                            value={clientResData.client_name}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                client_name: e.target.value,
                              });
                            }}
                            name="client_name"
                            placeholder={t("client_name")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("client_country_code")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            type="text"
                            className="form-control input-search"
                            value={clientResData.client_country_code}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                client_country_code: e.target.value,
                              });
                            }}
                            name="client_country_code"
                            placeholder={t("client_country_code")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my">
                        {"State"}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="text"
                            value={clientResData.client_district}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                client_district: e.target.value,
                              });
                            }}
                            name={`client_district`}
                            maxLength={50}
                            placeholder={t("district")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my">
                        {t("city")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="text"
                            value={clientResData.client_city}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                client_city: e.target.value,
                              });
                            }}
                            name={`client_city`}
                            maxLength={50}
                            placeholder={t("city")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("client_bill_address")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            type="text"
                            className="form-control input-search"
                            value={clientResData.client_bill_address}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                client_bill_address: e.target.value,
                              });
                            }}
                            name="client_bill_address"
                            placeholder={t("client_bill_address")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("client_postal_code")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            type="number"
                            className="form-control input-search"
                            value={clientResData.client_postal_code}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                client_postal_code: e.target.value,
                              });
                            }}
                            name="client_postal_code"
                            placeholder={t("client_postal_code")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("client_vat_country_code")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            type="text"
                            className="form-control input-search"
                            value={clientResData.client_vat_country_code}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                client_vat_country_code: e.target.value,
                              });
                            }}
                            name="client_vat_country_code"
                            placeholder={t("client_vat_country_code")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("client_vat_number")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            type="number"
                            className="form-control input-search"
                            value={clientResData.client_vat_number}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                client_vat_number: e.target.value,
                              });
                            }}
                            name="client_vat_number"
                            placeholder={t("client_vat_number")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("client_vat_percentage")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            type="number"
                            className="form-control input-search"
                            value={clientResData.client_vat_percentage}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                client_vat_percentage: e.target.value,
                              });
                            }}
                            name="client_vat_percentage"
                            placeholder={t("client_vat_percentage")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("client_indicative_phone_code")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            type="text"
                            className="form-control input-search"
                            value={clientResData.client_indicative_phone_code}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                client_indicative_phone_code: e.target.value,
                              });
                            }}
                            name="client_indicative_phone_code"
                            placeholder={t("client_indicative_phone_code")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("client_phone_number")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            type="number"
                            className="form-control input-search"
                            value={clientResData.client_phone_number}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                client_phone_number: e.target.value,
                              });
                            }}
                            name="client_phone_number"
                            placeholder={t("client_phone_number")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("client_whatsapp_number")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            type="number"
                            className="form-control input-search"
                            value={clientResData.client_whatsapp_number}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                client_whatsapp_number: e.target.value,
                              });
                            }}
                            name="client_whatsapp_number"
                            placeholder={t("client_whatsapp_number")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("client_email")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            type="text"
                            className="form-control input-search"
                            value={clientResData.client_email}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                client_email: e.target.value,
                              });
                            }}
                            name="client_email"
                            placeholder={t("client_email")}
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-3"></div>
                  <div className="col-md-3"></div>
                  <div className="col-md-3"></div>

                  <div className="col-md-12">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my">
                        Shipping Address
                      </Label>
                      <div className="col-xl-12">
                        {clientResData?.client_shipping_addresses?.map(
                          (address, index) => (
                            <div
                              key={index}
                              className="d-flex align-items-center mb-2"
                            >
                              <input
                                type="text"
                                className="form-control input-search mr-2"
                                placeholder={`Shipping address ${index + 1}`}
                                value={address}
                                onChange={(e) =>
                                  handleAddressChange(index, e.target.value)
                                }
                              />
                              <i
                                className="bi bi-x-circle"
                                style={{
                                  marginTop: "-41px",
                                  marginLeft: "-16px",
                                  color: "red",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleRemoveAddress(index)}
                              ></i>
                            </div>
                          )
                        )}

                        <button
                          type="button"
                          className="btn btn-primary btn-sm mt-2"
                          onClick={handleAddAddress}
                        >
                          ➕ Add Address
                        </button>
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-12">
                    <div
                      className="row"
                      style={{
                        overflowX: "auto",
                        maxHeight: "300px",
                      }}
                    >
                      <div className="card-body">
                        <div className="vehicleThBg table-responsive table-responsive-vehicle">
                          <table className="table table-bordered rounded-table table table-striped table-hover">
                            <thead>
                              <tr>
                                <th
                                  className="col-form-label ml-2 Label-my form-label"
                                  style={{ width: "10%" }}
                                >
                                  Part Name
                                </th>
                                <th
                                  className="col-form-label ml-2 Label-my form-label"
                                  style={{ width: "10%" }}
                                >
                                  Quantity
                                </th>

                                <th
                                  className="col-form-label ml-2 Label-my form-label"
                                  style={{ width: "10%" }}
                                >
                                  Entity
                                </th>
                                <th
                                  className="col-form-label ml-2 Label-my form-label"
                                  style={{ width: "10%" }}
                                >
                                  Price
                                </th>

                                <th
                                  className="col-form-label ml-2 Label-my form-label"
                                  style={{ width: "10%" }}
                                >
                                  Notes
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {taskDetails?.part_list?.length > 0 ? (
                                taskDetails.part_list.map((part) =>
                                  part?.part_qty_list?.map((qtyItem) => {
                                    const matchedTaskOrder =
                                      part.tasks_order_list?.find(
                                        (order) =>
                                          Number(order.part_qty_label_id) ===
                                          Number(qtyItem.id)
                                      );

                                    if (!matchedTaskOrder) return null;

                                    return (
                                      <tr
                                        key={`${part.parts_id}-${qtyItem.id}`}
                                      >
                                        <td>{part.namePartPT}</td>
                                        <td>{qtyItem.qty}</td>

                                        <td>
                                          <select
                                            className="form-select"
                                            value={
                                              selectedEntities[qtyItem.id] ??
                                              matchedTaskOrder?.location_id ??
                                              ""
                                            }
                                            onChange={(e) =>
                                              handleSelectChange(e, qtyItem)
                                            }
                                          >
                                            <option value="" disabled>
                                              Select
                                            </option>
                                            {renderOptions(entityTaskList)}
                                          </select>
                                        </td>

                                        <td>
                                          <div>
                                            <label>
                                              Price 1: {part?.part_price ?? "-"}
                                            </label>
                                          </div>
                                          <div>
                                            <label>
                                              Price 2:{" "}
                                              {part?.part_original_price ?? "-"}
                                            </label>
                                          </div>
                                          <div>
                                            <label>
                                              Cost Price:{" "}
                                              {part?.part_cost_price ?? "-"}
                                            </label>
                                          </div>
                                          <div>
                                            <label>
                                              Manual:
                                              <input
                                                type="number"
                                                value={
                                                  selectedPrices[qtyItem.id] ??
                                                  matchedTaskOrder?.tasks_sales_price ??
                                                  ""
                                                }
                                                onChange={(e) =>
                                                  handleManualInput(
                                                    qtyItem.id,
                                                    e.target.value
                                                  )
                                                }
                                                placeholder={t("enter_manual_price")}
                                                style={{
                                                  marginLeft: "10px",
                                                  width: "100px",
                                                }}
                                              />
                                            </label>
                                          </div>
                                        </td>

                                        <td>
                                          <div className="input-div">
                                            <textarea
                                              className="form-control"
                                              value={
                                                resOrderData
                                                  .reservation_order_notes?.[
                                                  qtyItem.id
                                                ] ??
                                                matchedTaskOrder?.tasks_details_notes ??
                                                ""
                                              }
                                              onChange={(e) =>
                                                setResOrderData((prev) => ({
                                                  ...prev,
                                                  reservation_order_notes: {
                                                    ...prev.reservation_order_notes,
                                                    [qtyItem.id]:
                                                      e.target.value,
                                                  },
                                                }))
                                              }
                                              name={`reservation_order_notes_${qtyItem.id}`}
                                              placeholder={t("notes")}
                                              rows={3}
                                            />
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })
                                )
                              ) : (
                                <tr>
                                  <td colSpan={6}>No parts available.</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleConvertToResClose}
              style={{ width: "100px", marginTop: "10px" }}
            >{t("close")}<i className="bi bi-x-lg"></i>
            </button>

            <button
              type="submit"
              className="btn btn-block btn-primary"
              style={{ width: "100px" }}
            >{t("yes")}<i className="bi bi-x-lg"></i>
            </button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modifyconverToSales} size="xl">
        <ModalHeader>{t("converted_to_sales")}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-3">
              <div className="Label-my">
                Sales Type{" "}
                <Select
                  className="my-select-v"
                  options={covertSalesList}
                  value={covertSalesList.find(
                    (item) => item.value == clientResData.sales_type
                  )}
                  onChange={(selectedOption) => {
                    setClientResData({
                      ...clientResData,
                      sales_type: selectedOption ? selectedOption.value : "",
                    });
                  }}
                  isSearchable={true}
                  isClearable={true}
                  placeholder={"Select Sales Type"}
                />
                {errors.sales_type && (
                  <span className="input-error">{errors.sales_type}</span>
                )}
              </div>
            </div>

            <div className="col-md-3">
              <div className="Label-my">
                Seller{" "}
                <Select
                  className="my-select-v"
                  options={userDataMainList}
                  value={userDataMainList.find(
                    (item) => item.value == clientResData.seller_id
                  )}
                  onChange={(selectedOption) => {
                    setClientResData({
                      ...clientResData,
                      seller_id: selectedOption ? selectedOption.value : "",
                    });
                  }}
                  isSearchable={true}
                  isClearable={true}
                  placeholder={"Select Seller"}
                />
                {errors.seller_id && (
                  <span className="input-error">{errors.seller_id}</span>
                )}
              </div>
            </div>

            <div className="col-md-3">
              <div className="Label-my">
                Sales Notes{" "}
                <textarea
                  type="text"
                  className="form-control input-search"
                  value={clientResData.sales_notes}
                  onChange={(e) => {
                    setClientResData({
                      ...clientResData,
                      sales_notes: e.target.value,
                    });
                  }}
                  name="sales_notes"
                  placeholder={t("sales_notes")}
                  rows={3}
                />
                {errors.sales_notes && (
                  <span className="input-error">{errors.sales_notes}</span>
                )}
              </div>
            </div>

            <div className="col-md-3">
              <FormGroup>
                <Label className="col-form-label">
                  {t("client_is_vat_exempt")}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div mt-12">
                    <div className="form-check">
                      <input
                        className="my-checkbox-1 form-check-input"
                        type="checkbox"
                        checked={clientResData.client_is_vat_exempt}
                        onChange={handleCheckboxChange}
                      />
                      <label className="form-check-label pl-6">
                        {t("client_is_vat_exempt")}
                      </label>
                    </div>
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-3">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my form-label form-label">
                  {t("client_name")}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      type="text"
                      className="form-control input-search"
                      value={clientResData.client_name}
                      onChange={(e) => {
                        setClientResData({
                          ...clientResData,
                          client_name: e.target.value,
                        });
                      }}
                      name="client_name"
                      placeholder={t("client_name")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-3">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my form-label form-label">
                  {t("client_country_code")}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      type="text"
                      className="form-control input-search"
                      value={clientResData.client_country_code}
                      onChange={(e) => {
                        setClientResData({
                          ...clientResData,
                          client_country_code: e.target.value,
                        });
                      }}
                      name="client_country_code"
                      placeholder={t("client_country_code")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-3">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {"State"}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientResData.client_district}
                      onChange={(e) => {
                        setClientResData({
                          ...clientResData,
                          client_district: e.target.value,
                        });
                      }}
                      name={`client_district`}
                      maxLength={50}
                      placeholder={t("district")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-3">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  {t("city")}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control input-search"
                      type="text"
                      value={clientResData.client_city}
                      onChange={(e) => {
                        setClientResData({
                          ...clientResData,
                          client_city: e.target.value,
                        });
                      }}
                      name={`client_city`}
                      maxLength={50}
                      placeholder={t("city")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-3">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my form-label form-label">
                  {t("client_bill_address")}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      type="text"
                      className="form-control input-search"
                      value={clientResData.client_bill_address}
                      onChange={(e) => {
                        setClientResData({
                          ...clientResData,
                          client_bill_address: e.target.value,
                        });
                      }}
                      name="client_bill_address"
                      placeholder={t("client_bill_address")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-3">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my form-label form-label">
                  {t("client_postal_code")}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      type="number"
                      className="form-control input-search"
                      value={clientResData.client_postal_code}
                      onChange={(e) => {
                        setClientResData({
                          ...clientResData,
                          client_postal_code: e.target.value,
                        });
                      }}
                      name="client_postal_code"
                      placeholder={t("client_postal_code")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-3">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my form-label form-label">
                  {t("client_vat_country_code")}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      type="text"
                      className="form-control input-search"
                      value={clientResData.client_vat_country_code}
                      onChange={(e) => {
                        setClientResData({
                          ...clientResData,
                          client_vat_country_code: e.target.value,
                        });
                      }}
                      name="client_vat_country_code"
                      placeholder={t("client_vat_country_code")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-3">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my form-label form-label">
                  {t("client_vat_number")}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      type="number"
                      className="form-control input-search"
                      value={clientResData.client_vat_number}
                      onChange={(e) => {
                        setClientResData({
                          ...clientResData,
                          client_vat_number: e.target.value,
                        });
                      }}
                      name="client_vat_number"
                      placeholder={t("client_vat_number")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-3">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my form-label form-label">
                  {t("client_vat_percentage")}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      type="number"
                      className="form-control input-search"
                      value={clientResData.client_vat_percentage}
                      onChange={(e) => {
                        setClientResData({
                          ...clientResData,
                          client_vat_percentage: e.target.value,
                        });
                      }}
                      name="client_vat_percentage"
                      placeholder={t("client_vat_percentage")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-3">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my form-label form-label">
                  {t("client_indicative_phone_code")}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      type="text"
                      className="form-control input-search"
                      value={clientResData.client_indicative_phone_code}
                      onChange={(e) => {
                        setClientResData({
                          ...clientResData,
                          client_indicative_phone_code: e.target.value,
                        });
                      }}
                      name="client_indicative_phone_code"
                      placeholder={t("client_indicative_phone_code")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-3">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my form-label form-label">
                  {t("client_phone_number")}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      type="number"
                      className="form-control input-search"
                      value={clientResData.client_phone_number}
                      onChange={(e) => {
                        setClientResData({
                          ...clientResData,
                          client_phone_number: e.target.value,
                        });
                      }}
                      name="client_phone_number"
                      placeholder={t("client_phone_number")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-3">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my form-label form-label">
                  {t("client_whatsapp_number")}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      type="number"
                      className="form-control input-search"
                      value={clientResData.client_whatsapp_number}
                      onChange={(e) => {
                        setClientResData({
                          ...clientResData,
                          client_whatsapp_number: e.target.value,
                        });
                      }}
                      name="client_whatsapp_number"
                      placeholder={t("client_whatsapp_number")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-3">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my form-label form-label">
                  {t("client_email")}
                </Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      type="text"
                      className="form-control input-search"
                      value={clientResData.client_email}
                      onChange={(e) => {
                        setClientResData({
                          ...clientResData,
                          client_email: e.target.value,
                        });
                      }}
                      name="client_email"
                      placeholder={t("client_email")}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-3"></div>
            <div className="col-md-3"></div>
            <div className="col-md-3"></div>

            <div className="col-md-12">
              <FormGroup>
                <Label className="col-form-label ml-2 Label-my">
                  Shipping Address
                </Label>
                <div className="col-xl-12">
                  {clientResData?.client_shipping_addresses?.map(
                    (address, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center mb-2"
                      >
                        <input
                          type="text"
                          className="form-control input-search mr-2"
                          placeholder={`Shipping address ${index + 1}`}
                          value={address}
                          onChange={(e) =>
                            handleAddressChange(index, e.target.value)
                          }
                        />
                        <i
                          className="bi bi-x-circle"
                          style={{
                            marginTop: "-41px",
                            marginLeft: "-16px",
                            color: "red",
                            cursor: "pointer",
                          }}
                          onClick={() => handleRemoveAddress(index)}
                        ></i>
                      </div>
                    )
                  )}

                  <button
                    type="button"
                    className="btn btn-primary btn-sm mt-2"
                    onClick={handleAddAddress}
                  >
                    ➕ Add Address
                  </button>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-12">
              <div
                className="row"
                style={{
                  overflowX: "auto",
                  maxHeight: "300px",
                }}
              >
                <div className="card-body">
                  <div className="vehicleThBg table-responsive table-responsive-vehicle">
                    <table className="table table-bordered rounded-table table table-striped table-hover">
                      <thead>
                        <tr>
                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            Part Name
                          </th>
                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            Quantity
                          </th>

                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            Entity
                          </th>
                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            Price
                          </th>

                          <th
                            className="col-form-label ml-2 Label-my form-label"
                            style={{ width: "10%" }}
                          >
                            Notes
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {taskDetails?.part_list?.length > 0 ? (
                          taskDetails.part_list.map((part) =>
                            part?.part_qty_list?.map((qtyItem) => {
                              const matchedTaskOrder =
                                part.tasks_order_list?.find(
                                  (order) =>
                                    Number(order.part_qty_label_id) ===
                                    Number(qtyItem.id)
                                );

                              if (!matchedTaskOrder) return null;

                              return (
                                <tr key={`${part.parts_id}-${qtyItem.id}`}>
                                  <td>{part.namePartPT}</td>
                                  <td>{qtyItem.qty}</td>

                                  <td>
                                    <select
                                      className="form-select"
                                      value={
                                        selectedEntities[qtyItem.id] ??
                                        matchedTaskOrder?.location_id ??
                                        ""
                                      }
                                      onChange={(e) =>
                                        handleSelectChange(e, qtyItem)
                                      }
                                    >
                                      <option value="" disabled>
                                        Select
                                      </option>
                                      {renderOptions(entityTaskList)}
                                    </select>
                                  </td>

                                  <td>
                                    <div>
                                      <label>
                                        Price 1: {part?.part_price ?? "-"}
                                      </label>
                                    </div>
                                    <div>
                                      <label>
                                        Price 2:{" "}
                                        {part?.part_original_price ?? "-"}
                                      </label>
                                    </div>
                                    <div>
                                      <label>
                                        Cost Price:{" "}
                                        {part?.part_cost_price ?? "-"}
                                      </label>
                                    </div>
                                    <div>
                                      <label>
                                        Manual:
                                        <input
                                          type="number"
                                          value={
                                            selectedPrices[qtyItem.id] ??
                                            matchedTaskOrder?.tasks_sales_price ??
                                            ""
                                          }
                                          onChange={(e) =>
                                            handleManualInput(
                                              qtyItem.id,
                                              e.target.value
                                            )
                                          }
                                          placeholder={t("enter_manual_price")}
                                          style={{
                                            marginLeft: "10px",
                                            width: "100px",
                                          }}
                                        />
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    <div className="input-div">
                                      <textarea
                                        className="form-control"
                                        value={
                                          resOrderData
                                            .reservation_order_notes?.[
                                            qtyItem.id
                                          ] ??
                                          matchedTaskOrder?.tasks_details_notes ??
                                          ""
                                        }
                                        onChange={(e) =>
                                          setResOrderData((prev) => ({
                                            ...prev,
                                            reservation_order_notes: {
                                              ...prev.reservation_order_notes,
                                              [qtyItem.id]: e.target.value,
                                            },
                                          }))
                                        }
                                        name={`reservation_order_notes_${qtyItem.id}`}
                                        placeholder={t("notes")}
                                        rows={3}
                                      />
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          )
                        ) : (
                          <tr>
                            <td colSpan={6}>No parts available.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {Number(settingCompanyDetails?.is_all_sync) === 1 && (
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("expirationDate")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <input
                            className="form-control input-search"
                            type="date"
                            value={clientResData.expiration_date}
                            onChange={(e) => {
                              setClientResData({
                                ...clientResData,
                                expiration_date: e.target.value,
                              });
                            }}
                            name="expiration_date"
                            placeholder={t("expiration_date")}
                          />
                        </div>
                        {/* {errors.expiration_date && (
                          <span className="input-error">
                            {errors.expiration_date}
                          </span>
                        )} */}
                      </div>
                    </FormGroup>
                  </div>

                  <div className="col-md-4">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("documentSet")}
                      </Label>
                      <div className="col-xl-12">
                        <div className="input-div">
                          <Select
                            className="my-select-v"
                            options={documentSetList}
                            value={documentSetList.find(
                              (item) =>
                                item.value === clientResData.document_set_id
                            )}
                            onChange={(selectedOption) => {
                              setClientResData({
                                ...clientResData,
                                document_set_id: selectedOption
                                  ? selectedOption.value
                                  : "",
                              });
                            }}
                            isSearchable={true}
                            isClearable={true}
                            placeholder={"Select Document Set"}
                          />
                          {/* {errors.document_set_id && (
                            <span className="input-error">
                              {errors.document_set_id}
                            </span>
                          )} */}
                        </div>
                      </div>
                    </FormGroup>
                  </div>
                  <div className="col-md-4" />
                </div>
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleConvertToSaleClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "100px" }}
            onClick={handleSubmitConvertToSales}
          >{t("yes")}<i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyUpdateTask}>
        <ModalHeader>{`Update Task`}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>{`Are you sure you want finish the task?`}</p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleUpdateTaskClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("no")}<i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "100px" }}
            onClick={handleUpdateTaskSubmit}
          >{t("yes")}<i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Task;
